import { useEffect } from "react";
import LinkButton from "src/components/buttons/LinkButton";
import Breadcrumbs from "src/components/layout/Breadcrumbs";
import Container from "src/components/layout/Container";
import Section from "src/components/layout/Section";
import helmet from "src/utils/helmet";

export default function SuperAdminSettings(props) {
  useEffect(() => {
    helmet.setPageTitle("Super Admin Settings");
  }, []);

  return (
    <Section>
      <Container>
        <Breadcrumbs>
          <LinkButton to="/super-admin">Super Admin Home</LinkButton> / Settings
        </Breadcrumbs>
        <h1>Settings</h1>

        <hr className="-mx-4 my-0" />

        <LinkButton
          to={`/super-admin/settings/general`}
          className="flex items-center py-4"
        >
          <div className="flex-1">
            <i aria-hidden className="far fa-gear mr-2" />
            <strong className="text-dark">General Settings</strong>
          </div>
          <i aria-hidden className="far fa-chevron-right" />
        </LinkButton>

        <hr className="-mx-4 my-0" />

        <LinkButton
          to={`/super-admin/settings/tags`}
          className="flex items-center py-4"
        >
          <div className="flex-1">
            <i aria-hidden className="far fa-tags mr-2" />
            <strong className="text-dark">Tags</strong>
          </div>
          <i aria-hidden className="far fa-chevron-right" />
        </LinkButton>

        <hr className="-mx-4 my-0" />

        <LinkButton
          to={`/super-admin/settings/needs`}
          className="flex items-center py-4"
        >
          <div className="flex-1">
            <i aria-hidden className="far fa-list-check mr-2" />
            <strong className="text-dark">Custom Needs</strong>
          </div>
          <i aria-hidden className="far fa-chevron-right" />
        </LinkButton>

        <hr className="-mx-4 my-0" />

        <LinkButton
          to={`/super-admin/settings/time-standards`}
          className="flex items-center py-4"
        >
          <div className="flex-1">
            <i aria-hidden className="far fa-stopwatch mr-2" />
            <strong className="text-dark">Time Standards</strong>
          </div>
          <i aria-hidden className="far fa-chevron-right" />
        </LinkButton>

        <hr className="-mx-4 my-0" />
      </Container>
    </Section>
  );
}
